import { Chip } from '@mui/material';

import { useStyles } from '@/features/DevicesTable';
import { getStatusColor } from '@/pages/Administration/Devices/Devices.service';
import type {
  LimaSourceAggregatedStatusModel,
  StatusGroup
} from '@/pages/Administration/Devices/SyncDevices/SyncDevices.types';

import type { SourceStatusCountsChipsProps } from './SourceStatusCountsChips.types';

// Reusable component for displaying status counts grouped by status code as chips.
const SourceStatusCountsChips = (props: SourceStatusCountsChipsProps) => {
  const { row } = props;
  const { classes } = useStyles();
  // building chip config dynamically
  const buildChipsConfig = (statusGroups: StatusGroup[]) =>
    statusGroups.map((group) => {
      let computeValue:
        | ((aggRow: LimaSourceAggregatedStatusModel) => number)
        | undefined;
      let key: string;
      if (group.codePrefix === '1/null') {
        key = 'group_1xxx+null';
        computeValue = (aggRow: LimaSourceAggregatedStatusModel) =>
          Number(aggRow.group_1xxx ?? 0) + Number(aggRow.group_null ?? 0);
      } else {
        key = `group_${group.codePrefix}xxx`;
      }
      return {
        key,
        color: group.color,
        label: group.label,
        computeValue
      };
    });

  const chipsConfig = buildChipsConfig(row.statusGroups || []);

  return (
    <>
      {chipsConfig.map((chip) => {
        let value = 0;
        if (chip.computeValue) {
          value = chip.computeValue(row);
        } else if (row && chip.key in row) {
          value = Number((row as Record<string, unknown>)[chip.key]) || 0;
        }
        if (value > 0) {
          return (
            <Chip
              key={chip.key}
              className={classes.chipMarginGap}
              label={`${value}`}
              variant="filled"
              color={getStatusColor(chip.color)}
              size="small"
            />
          );
        }
        return null;
      })}
    </>
  );
};

export default SourceStatusCountsChips;
